import React, { useState } from "react";
import { Card, CardBody, CardHeader, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import IDIMGUploadComponent from "../../../components/IdImageUploadComponent";
import IMGUploadComponent from "../../../components/IMGUploadComponent";
import BreadCrumbs from "../../../components/BreadCrumbs";
import ControlledRowTextField from "../../../components/ControlledRowTextField";
import ButtonComponent from "../../../components/ButtonComponent";
import {
  useCreateCartPersonMutation,
  useUploadCartPersonIdentityDocumentFileExtntionHttpsMutation,
  useUploadCartPersonImageFileExtntionHttpsMutation,
} from "../../../redux/services/cartSearchService";
import { uploadImage } from "../../../components/imageUploadCompont";
import { toast } from "react-toastify";
import { uploadIDDocImage } from "../../../components/ImageUploadComponent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { Col, Label, Row } from "reactstrap";

const CreateCartPerson = () => {
  const navigate = useNavigate();

  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [canSelfRegisterCarts, setCanSelfRegisterCarts] = useState(false);
  const [canCollectCash, setCanCollectCash] = useState(false);

  const [uploadedImgDetails, setUploadedImgDetails] = useState<{
    imgSrc: string;
    formData: any;
    fileExtention: string;
  }>({
    imgSrc: "",
    formData: "",
    fileExtention: "",
  });
  const [uploadedIDImgDetails, setUploadedIDImgDetails] = useState<{
    imgSrc: string;
    formData: any;
    fileExtension: string;
    documentType: string;
  }>({
    imgSrc: "",
    formData: "",
    fileExtension: "",
    documentType: "Identity",
  });
  const {
    control,
    handleSubmit,
    formState: { errors },
    setError,
    clearErrors,
    setValue
  } = useForm<any>({
    defaultValues: {
      address: "",
      displayName: "",
      location: { latitude: 0, longitude: 0 },
      image: "",
      idimage: "",
      canSelfRegisterCarts: false,
      canCollectCash: false,
    },
  });

  const imageUploadCallback = (e: any) => {
    setUploadedImgDetails({
      ...uploadedImgDetails,
      imgSrc: e.imgSrc,
      formData: e.formData,
      fileExtention: e.fileExtention,
    });
    clearErrors("image");
  };

  const iDImageUploadCallback = (e: any) => {
    setUploadedIDImgDetails({
      ...uploadedIDImgDetails,
      imgSrc: e.imgSrc,
      formData: e.formData,
      fileExtension: e.fileExtension,
    });
    clearErrors("idimage");
  };

  const [createCartPerson] = useCreateCartPersonMutation();
  const [uploadCartPersonImageFileExtetion] =
    useUploadCartPersonImageFileExtntionHttpsMutation();
  const [
    uploadCartPersonIdentityDocumentFileExtetion,
  ] = useUploadCartPersonIdentityDocumentFileExtntionHttpsMutation();

  const onSubmit = async (data: any) => {
    if (!uploadedImgDetails.imgSrc) {
      setError("image", {
        type: "manual",
        message: "Image is required.",
      });
      return;
    }

    if (!uploadedIDImgDetails.imgSrc) {
      setError("idimage", {
        type: "manual",
        message: "ID Image is required.",
      });
      return;
    }

    setIsSubmitLoading(true);

    try {
      const imageReference = await uploadImage(
        uploadCartPersonImageFileExtetion,
        uploadedImgDetails
      );
      const identityDocReference = await uploadIDDocImage(
        uploadCartPersonIdentityDocumentFileExtetion,
        uploadedIDImgDetails
      );
      data.identityDocReference = identityDocReference;
      const cartPersonData = {
        displayName: data.displayName,
        email: data.email,
        phoneNumber: data.phoneNumber,
        merchantId: data.merchantId,
        identityDocReference: identityDocReference,
        imageReference: imageReference,
        canSelfRegisterCarts: data.canSelfRegisterCarts,
        canCollectCash: data.canCollectCash,
      };
      const response = await createCartPerson(cartPersonData).unwrap();
      if (response.originalStatus === 409) {
        setIsSubmitLoading(false);
        toast.error("This email in use.");
        return;
      }
      setIsSubmitLoading(false);
      toast.success("Cart Created Successfully.");
      navigate("/cartpersons/cartperson-list");
    } catch (error: any) {
      if (error.data === "This merchant Id Already Assigned to a Cart Person") {
        setIsSubmitLoading(false);
        toast.error("This merchant Id Already Assigned to a Cart Person");
        return;
      }
      if (error.originalStatus === 409) {
        setIsSubmitLoading(false);
        toast.error("This email in use.");
      } else {
        setIsSubmitLoading(false);
        toast.error("Could not create cart");
      }
      setIsSubmitLoading(false);
    }
  };
  return (
    <>
      <BreadCrumbs hasSubMenus={false} />
      <Card className="mt-3">
        <CardHeader className="bg-white">
          <h4>Create Cart Person</h4>
        </CardHeader>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <CardBody>
            <IMGUploadComponent
              imageUrl={uploadedImgDetails.imgSrc}
              onUpload={imageUploadCallback}
            />
            <Row>
              <Col lg="4">{""}</Col>
              <Col lg="8">
                {errors.image && (
                  <span className="validation-message text-danger">
                    {String(errors.image.message)}
                  </span>
                )}
              </Col>
            </Row>

            <hr />

            <ControlledRowTextField
              inputName={"displayName"}
              inputType={"text"}
              autoComplete={"off"}
              placeholder={"Enter Full Name"}
              label={"Full Name"}
              control={control}
              rules={{ required: "Cart name is required." }}
              errors={errors}
            />
            <Row>
              <Col lg="4">{""}</Col>
              <Col lg="8">
                {errors.displayName && (
                  <span className="validation-message text-danger">
                    {String(errors.displayName.message)}
                  </span>
                )}
              </Col>
            </Row>

            <hr />
            <ControlledRowTextField
              inputName={"email"}
              inputType={"text"}
              autoComplete={"off"}
              placeholder={"Enter Email Address"}
              label={"Email Address"}
              control={control}
              rules={{
                required: "Email is required.",
                pattern: {
                  value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                  message: "Invalid email format.",
                },
              }}
              errors={errors}
            />
            <Row>
              <Col lg="4">{""}</Col>
              <Col lg="8">
                {errors.email && (
                  <span className="validation-message text-danger">
                    {String(errors.email.message)}
                  </span>
                )}
              </Col>
            </Row>

            <hr />

            <ControlledRowTextField
              inputName={"phoneNumber"}
              inputType={"text"}
              autoComplete={"off"}
              placeholder={"Enter Mobile Number"}
              label={"Mobile Number"}
              control={control}
              rules={{
                required: "Phone number is required.",
                minLength: {
                  value: 10,
                  message: "Phone number must be at least 10 digits.",
                },
                maxLength: {
                  value: 15,
                  message: "Phone number can't exceed 15 digits.",
                },
                pattern: {
                  value: /^(?:\+94|0)?[0-9]{9}$/,
                  message:
                    "Phone number must be either in +94xxxxxxxxx or 0xxxxxxxxx format.",
                },
              }}
              errors={errors}
            />

            <Row>
              <Col lg="4">{""}</Col>
              <Col lg="8">
                {errors.phoneNumber && (
                  <span className="validation-message text-danger">
                    {String(errors.phoneNumber.message)}
                  </span>
                )}
              </Col>
            </Row>
            <hr />
            <ControlledRowTextField
              inputName={"merchantId"}
              inputType={"text"}
              autoComplete={"off"}
              placeholder={"Enter Merchant Id"}
              label={"Merchant Id"}
              control={control}
              errors={errors}
            />
            <hr />
            <Row>
              <Col lg="4">
                <Label
                  className="form-check-label"
                  htmlFor="supportsDirectOrders"
                >
                  Self Register Cart
                </Label>
              </Col>
              <Col lg="8">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="canSelfRegisterCarts"
                  checked={canSelfRegisterCarts}
                  onChange={(
                    event: React.ChangeEvent<HTMLInputElement>
                  ) => {
                    setCanSelfRegisterCarts(event.target.checked);
                    setValue("canSelfRegisterCarts", event.target.checked);
                  }}
                />
              </Col>
            </Row>
            
            {/* New Can Collect Cash Checkbox */}
            <hr />
            <Row>
              <Col lg="4">
                <Label
                  className="form-check-label"
                  htmlFor="canCollectCash"
                >
                  Can Collect Cash
                </Label>
              </Col>
              <Col lg="8">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="canCollectCash"
                  checked={canCollectCash}
                  onChange={(
                    event: React.ChangeEvent<HTMLInputElement>
                  ) => {
                    setCanCollectCash(event.target.checked);
                    setValue("canCollectCash", event.target.checked);
                  }}
                />
              </Col>
            </Row>

            <hr />
            <IDIMGUploadComponent
              imageUrl={uploadedIDImgDetails.imgSrc}
              onUpload={iDImageUploadCallback}
            />

            <Row>
              <Col lg="4">{""}</Col>
              <Col lg="8">
                {errors.idimage && (
                  <span className="validation-message text-danger">
                    {String(errors.idimage?.message)}
                  </span>
                )}
              </Col>
            </Row>

            <div className="d-flex justify-content-end mx-2 my-3">
              {isSubmitLoading ? (
                <>
                  <ButtonComponent
                    titel="Saving..."
                    icon={<FontAwesomeIcon icon={faSpinner} spin />}
                    isDisabled={true}
                  />
                </>
              ) : (
                <>
                  <ButtonComponent titel="Submit" type="submit" />
                </>
              )}
            </div>
          </CardBody>
        </Form>
      </Card>
    </>
  );
};

export default CreateCartPerson;